export const initialState = {
    settings: {},
    ducInwardRows: [],
    ducInwardOriginalRows: [],    
    loadingDUCInward:false,
}